import Vue from 'vue'
import axios from 'axios';
import iView from 'iview'
import { Message } from 'iview';
import router from '../router/index'

var service = axios.create({
    responseType: 'json',
    timeout: 50000,
    "xhrFields" : {
		"withCredentials" : true
	},
	"crossDomain" : true,
});
// 添加请求拦截器
service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    iView.LoadingBar.start();
	const access_token= sessionStorage.getItem("token")
  config.headers["Authorization"]="bearer "+access_token
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    iView.LoadingBar.finish();
    if(response.data.ret==408){
      //token过期
      Message.error({
          content:response.data.msg,
          duration: 5
      });
      sessionStorage.removeItem('token');
      setTimeout(function(){
       router.push('/login/');
      },1000)

    }else if(response.data.ret!==200){
      Message.error({
          content:response.data.msg,
          duration: 5
      });
    }
    return response;
  }, function (error) {
    // 对响应错误做点什么
    if(error && error.response){
      switch (error.response.status){
        case 400:
          Message.error({content:"错误请求",duration: 5});
          error.message="错误请求";
          break;
        case 401:
          Message.error({content:"请重新登录",duration: 5});
          error.message="错误请求";
          sessionStorage.removeItem('token');
          setTimeout(function(){
           router.push('/login/');
          },1000)
          break;
        case 403:
          Message.error({content:"拒绝访问",duration: 5});
          error.message="拒绝访问";
		  console.log("拒绝访问")
          break;
        case 404:
          Message.error({content:"请求错误，未找到资源",duration: 5});
          error.message="请求错误，未找到资源";
		  console.log("请求错误，未找到资源")
          break;
        case 405:
          // Message.error({content:"请求方法未允许",duration: 5});
          // error.message="请求方法未允许";
		  console.log("请求方法未允许")
          break;
        case 408:
          // Message.error({content:"请求超时",duration: 5});
          // error.message="请求超时";
		  console.log("请求超时")
          break;
        case 500:
          Message.error({content:"服务器出错",duration: 5});
          error.message="服务器出错";
          break;
        case 501:
          // Message.error({content:"网路未实现",duration: 5});
          // error.message="网路未实现";
		  console.log("网路未实现")
          break;
        case 502:
			console.log("网路错误")
          // Message.error({content:"网路错误",duration: 5});
          // error.message="网路错误";
          break;
        case 503:
          // Message.error({content:"服务不可用",duration: 5});
          // error.message="服务不可用";
		  console.log("服务不可用")
          break;
        case 504:
          // Message.error({content:"网络超时",duration: 5});
          // error.message="网络超时";
		  console.log("网络超时")
          break;
        case 505:
          // Message.error({content:"http版本不支持该请求",duration: 5});
          // error.message="http版本不支持该请求";
		   console.log("http版本不支持该请求")
          break;
        default:
          Message.error({content:`连接错误-${error.response.status}`,duration: 5});
          error.message=`连接错误-${error.response.status}`;
      }
    }else{
      // Message.error({content:"网络出现问题请稍后再试！",duration: 5});
      // error.message="网络出现问题请稍后再试！";
	  console.log("网络出现问题请稍后再试")
    }
    
    return Promise.reject(error);
  });
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js